import siteList from '../../site/site.List.i18n'

//restful api
import { policy as wmds } from '@/service/api/wmds'

const policy = {
  S : { depth: 5, links: 20, limit: 50 },
  M : { depth: 10, links: 50, limit: 2000 },
  L : { depth: 20, links: 100, limit: 10000 }
}
export default {
  components : { siteList },
  data : () => {
    return {
      limit : 0,
      confirm: false,
      add: false,
      lock: true,
      model : { description: 'Sample', policy: { depth: 5, links: 20, limit: 0, timeout: 5, delay: 500 } },
      policy : policy,
      config : {},
    }
  },
  computed : {

  },
  methods: {
    async check_max_page(){
      let rs = await wmds.pagePolicy()
      if(rs.error) { return this.$toastr.e("license check failed") }
      this.model.policy.limit = rs.body;
      this.limit = this.model.policy.limit
    },
    cancel() { this.$router.replace({ name: 'wmds_policy', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'wmds_policy', params: { id: this.model.id, tag: 'edit' }}); },
    refresh() { this.$emit("refresh") },
    async remove() {
      try{
        let rs = await wmds.deletePolicy({ id : this.model.id })
        if(rs.error) { return this.$toastr.e("delete failed") }

        this.$emit('refresh'), this.$toastr.s('Removed'), this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_policy'}); },
    async save() {
      let config = this.model;
      try {
        let check_id = '';
        check_id = this.model.id ? 'update' : 'insert';

        if(check_id == 'update'){
          let rs = await wmds.updatePolicy(config);

          if(rs.error) { this.cancel(); return this.$toastr.e("load failed") }

          let id = rs.body.id
          this.$router.push({ name: 'wmds_policy', params : { id : id } })

          this.$toastr.s('Saved');
          this.refresh()
        }else{
          let rs = await wmds.insertPolicy(config);

          if(rs.error) { this.cancel(); return this.$toastr.e("load failed") }

          let id = rs.body.id
          this.$router.push({ name: 'wmds_policy', params : { id : id } })

          this.$toastr.s('Saved');
          this.refresh()
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText); this.list();  }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      try{
        this.add = false;
        console.log('policy.detail.vue', 'load item', id);

        if(id === 'add') { this.check_max_page(); this.add = true; this.lock = false; return; }

        this.lock = (tag !== 'edit');

        let rs = await wmds.detailPolicy({ id : id })
        if(rs.error) { return this.$toastr.e("load failed", this.$route.name) }
        this.model = Object.assign({ group: {}}, this.model, rs.body)
      }catch(e){ this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params);}},
  created() { console.log('policy.detail.vue', 'created'); },
  destroyed() { console.log('policy.detail.vue', 'destroyed'); },
  mounted() {
    console.log('policy.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}